import { Link } from 'react-router-dom';
import { MapPin, Bed } from 'lucide-react';
import { motion } from 'framer-motion';

export const PropertyCard = ({ property }) => {
  return (
    <motion.div
      whileHover={{ y: -8 }}
      className="bg-white rounded-2xl overflow-hidden shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_24px_rgba(91,45,139,0.1)] transition-all duration-300 border border-gray-100"
      data-testid={`property-card-${property.id}`}
    >
      <div className="aspect-video relative overflow-hidden">
        <img
          src={property.images[0]}
          alt={property.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 right-4 bg-brand-orange text-white px-3 py-1 rounded-full font-body text-sm font-semibold">
          ₹{Math.min(...Object.values(property.pricing).filter(p => p > 0))}/month
        </div>
      </div>

      <div className="p-6">
        <h3 className="font-heading text-xl font-semibold text-gray-900 mb-2">
          {property.name}
        </h3>
        
        <div className="flex items-center gap-2 text-gray-600 mb-4">
          <MapPin size={16} className="text-brand-purple" />
          <span className="font-body text-sm">{property.area}</span>
        </div>

        <div className="flex items-center gap-4 mb-4">
          <div className="flex items-center gap-2">
            <Bed size={16} className="text-gray-400" />
            <span className="font-body text-sm text-gray-600">
              {property.room_types.join(', ')}
            </span>
          </div>
        </div>

        <Link
          to={`/properties/${property.id}`}
          data-testid={`property-view-button-${property.id}`}
          className="block w-full bg-brand-purple text-white text-center py-3 rounded-full font-body font-medium hover:bg-opacity-90 transition-all"
        >
          View Details
        </Link>
      </div>
    </motion.div>
  );
};
